"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpServiceEnhancedPromise = void 0;
/**
 * ## Http Service Enhanced Promises
 * To improve the usability of HttpService, we added the ability to easily grab the response headers and cancel the request all together. The request methods (get, post, etc) now return a HttpServiceEnhancedPromise that allows you to change what data you want returned from the HttpService while keeping all current usages intact.
 *
 * Example HttpServiceEnhancedPromise asResponse() functionality
 * ```
 * const httpService = instance.getService(HttpService); // or instance.getService('HttpService')
 *
 * async function myRequest() {
 *   const enhancedPromise: HttpServiceEnhancedPromise<any> = httpService.get('{YOUR_URL}').asResponse(); // returns a promise as we did not await
 *   const response: HttpServiceResponse<any> = await enhancedPromise; // wait for the response to finish
 *   // You could alternatively write this instead of lines 4 and 5 to do it in one line, but you will not be able to cancel the promise
 *   // const response: HttpServiceResponse<any> = await httpService.get('{YOUR_URL}').asResponse(); // wait for the response to finish
 *   if (response.ok) {
 *     // Response returned a 200-299 STATUS CODE
 *   }
 *   if (response.redirected) {
 *     // Response returned a 300-399 STATUS CODE
 *   }
 *   const someHeader = response.headers.get('some-header');
 * }
 * ```
 *
 * Example Cancellation
 * ```
 * const httpService = instance.getService(HttpService); // or instance.getService('HttpService')
 *
 * async function myRequest() {
 *   const enhancedPromise = httpService.get('{YOUR_URL}'); // Noted the lack of await here
 *   setTimeout(() => enhancedPromise.cancel(), 100);
 *   try {
 *     await enhancedPromise; // wait for the response to finish
 *     // Request was completed within 100ms
 *   } catch (ex) {
 *     if (enhancedPromise.cancelled) {
 *       // Your request was cancelled!
 *     }
 *   }
 * }
 * ```
 * @category HTTP
 */
var HttpServiceEnhancedPromise = /** @class */ (function () {
    function HttpServiceEnhancedPromise(executor, onCancelledCallback, responsePromise, promise) {
        this.executor = executor;
        this.onCancelledCallback = onCancelledCallback;
        this.responsePromise = responsePromise;
        this._cancelled = false;
        this.promise = promise || new Promise(executor);
    }
    Object.defineProperty(HttpServiceEnhancedPromise.prototype, Symbol.toStringTag, {
        get: function () {
            return 'HttpServiceEnhancedPromise';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpServiceEnhancedPromise.prototype, "cancelled", {
        get: function () {
            return this._cancelled;
        },
        enumerable: false,
        configurable: true
    });
    HttpServiceEnhancedPromise.prototype.then = function (onfulfilled, onrejected) {
        return new HttpServiceEnhancedPromise(this.executor, this.onCancelledCallback, this.responsePromise, this.promise.then(onfulfilled, onrejected));
    };
    HttpServiceEnhancedPromise.prototype.catch = function (onrejected) {
        var returnValue = new HttpServiceEnhancedPromise(this.executor, this.onCancelledCallback, this.responsePromise, this.promise.catch(onrejected));
        return returnValue;
    };
    HttpServiceEnhancedPromise.prototype.finally = function (onfinally) {
        return new HttpServiceEnhancedPromise(this.executor, this.onCancelledCallback, this.responsePromise, this.promise.finally(onfinally));
    };
    HttpServiceEnhancedPromise.prototype.asResponse = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.cancelled) {
                    throw new Error('Request was cancelled');
                }
                if (!this.responsePromise) {
                    throw new Error('Not init yet!');
                }
                return [2 /*return*/, this.responsePromise];
            });
        });
    };
    /**
     * Will automatically remove observers after cancellation
     */
    HttpServiceEnhancedPromise.prototype.cancel = function () {
        this._cancelled = true;
        this.onCancelledCallback && this.onCancelledCallback();
    };
    return HttpServiceEnhancedPromise;
}());
exports.HttpServiceEnhancedPromise = HttpServiceEnhancedPromise;
//# sourceMappingURL=HttpServiceEnhancedPromise.js.map